import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private snackBar: MatSnackBar) { }

  openSnackbar(message: string, color: string, duration: number = 3000) {
    this.snackBar.open(message, undefined, {
      duration: duration,
      panelClass: [color],
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }

  openCancelableSnackbar(message: string, color: string): MatSnackBarRef<TextOnlySnackBar> {
    const snackBarRef = this.snackBar.open(message, '✖', {
      duration: 0, 
      panelClass: [color, 'center-green-snackbar'],
      verticalPosition: 'top', 
      horizontalPosition: 'center',
    });
 
    snackBarRef.onAction().subscribe(() => {
      snackBarRef.dismiss();
    });
 
    return snackBarRef;
  }
}